import React, { Component } from "react";
import IconButton from "@material-ui/core/IconButton";
import VerticalAlignCenterIcon from "@material-ui/icons/VerticalAlignCenter";
import i18n from "i18next";

class DiscreteFlag extends Component {
  addFieldToDiscrete = () => {
    const {
      column,
      setQuery,
      discrete,
      data: {
        query,
        query: { discreteFlags },
      },
    } = this.props;
    let newDiscreteFlags = [...discreteFlags, column.field];
    setQuery({ ...query, discreteFlags: newDiscreteFlags });
    discrete(newDiscreteFlags);
  };

  removeFieldFromDiscrete = () => {
    const {
      column,
      setQuery,
      discrete,
      data: {
        query,
        query: { discreteFlags },
      },
    } = this.props;

    let newDiscreteFlags = discreteFlags.filter((r) => r !== column.field);
    setQuery({ ...query, discreteFlags: newDiscreteFlags });
    discrete(newDiscreteFlags);
  };

  render() {
    const {
      classes,
      column,
      data: {
        query: { discreteFlags },
      },
    } = this.props;
    let isActive = discreteFlags?.find((r) => r === column.field) ? true : false;
    return (
      <span
      
      className={`DiscreteIconsContainer ${!isActive ? "hideInactive" : ""}`}


        title={i18n.t("libraryTools.discreteBy")}
        onClick={() =>
          isActive ? this.removeFieldFromDiscrete() : this.addFieldToDiscrete()
        }
      >
        <IconButton>
          {isActive ? (
            <VerticalAlignCenterIcon
            className={classes.activeleDiscreteIcons}
              style={{ fontSize: "15px" }}
              color="primary"
            />
          ) : (
            <VerticalAlignCenterIcon
       className={classes.disableDiscreteIcons}
              style={{ fontSize: "15px" }}
              color="disabled"
            />
          )}
        </IconButton>
      </span>
    );
  }
}

export default DiscreteFlag;
